import * as React from 'react';
import { Pagination } from 'react-admin';

export const CommonPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export default CommonPagination;
